module.exports = __webpack_public_path__ + "img/small.3edfa9e8.jpg";